import { ChangeDetectionStrategy, Component, inject, Input, OnInit } from '@angular/core';
import { Location } from '@angular/common';

import { IDynamicElement } from '../_shared/models/dynamic/dynamic-element.model';
import { IArticleInfoBar } from '../_shared/models/article-info-bar.model';
import { IChip } from '../_shared/models/chip.model';
import { ISocialMediaItem } from '../_shared/models/social-media-links.model';
import { SocialMediaIconService } from '../_shared/services/social-media-icon.service';
import { LinkService } from '../_shared/services/link.service';
import { SnowplowService } from '../_shared/services/snowplow.service';
import { GtmService } from '../_shared/services/gtm.service';
import { TrackingEvents } from '../_shared/data/tracking-events.data';
import { ChipsComponent } from '../chip/chips.component';
import { IconComponent } from '../icon/icon.component';
import { TranslateModule } from '@ngx-translate/core';
import { LinkDirective } from '../_shared/directives/link.directive';
import { ContainerComponent } from '../container/container.component';

@Component({
    selector: 'sirius-article-info-bar',
    templateUrl: './article-info-bar.component.html',
    styleUrls: ['./article-info-bar.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'sir-text-style-paragraph-l-default' },
    imports: [
    ContainerComponent,
    ChipsComponent,
    LinkDirective,
    IconComponent,
    TranslateModule
]
})
export class ArticleInfoBarComponent implements OnInit, IDynamicElement {
    @Input() config?: IArticleInfoBar;
    @Input() authorName = '';
    @Input() publishedAt = '';
    @Input() tags: IChip[] = [];
    @Input() socialMediaLinks: ISocialMediaItem[] = [];

    private _socialMediaIconService = inject(SocialMediaIconService);
    private _gtmService = inject(GtmService);
    private _snowplowService = inject(SnowplowService);
    private _location = inject(Location);
    private _linkService = inject(LinkService);

    ngOnInit(): void {
        if (this.config) {
            this.authorName = this.config.authorName;
            this.tags = this.config.tags;
            this.socialMediaLinks = this.config.socialMediaLinks;
            this.publishedAt = this.config.publishedAt;
        }

        this.socialMediaLinks.forEach(
            (x: ISocialMediaItem) => (x.icon = this._socialMediaIconService.getIconName(x.itemType))
        );
    }

    onClick(item: ISocialMediaItem) {
        this.addTracking(item);
    }

    //#region tracking
    private addTracking(item: ISocialMediaItem) {
        const slug = this._linkService.getSlug(this._location.path());
        const cfg = {
            content_name: slug,
            method: item.itemType,
        };

        this._gtmService.track(TrackingEvents.gtm['share']([cfg]));

        const cfg2 = {
            method: item.itemType,
            context: [],
        };

        this._snowplowService.track('share', cfg2);
    }
    //#endregion
}
